import { algoliasearch } from 'algoliasearch';
import {
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_KEY,
  ALGOLIA_PRODUCTS_INDEX,
  isAlgoliaConfigured,
} from '../../config/env';

export { ALGOLIA_PRODUCTS_INDEX, isAlgoliaConfigured };

let client = null;

export function getAlgoliaClient() {
  if (!isAlgoliaConfigured()) {
    return null;
  }
  if (!client) {
    client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  }
  return client;
}
